/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import { showElementCss } from '../../../../utils/responsive';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { processButtonData } from '../../../../utils/analytics';
import { ModalsConsumer, modalIds } from '../../../../contexts/ModalsContext';
import createButtonCss from '../../../ui/Button/Button';
import { defaultData } from '../data';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { Container, Row, Column } from '../../../../styles/Grid';
import LinkWrapper from '../../../ui/LinkWrapper';
import { trackEvent } from '../../../../services/clienteventtracking';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import {
  containerCtaCss,
  secondaryButtonCss,
  dividerCss,
} from './index.styles';

export class Form extends SafePureComponent {
  secondaryButtonRef = React.createRef();

  handleEnquirySubmit = (e, openModal, fields) => {
    e.preventDefault();

    const enquiryDefaultValues = {
      Location: fields.ProtonName.value,
    };

    openModal(modalIds.enquiry, enquiryDefaultValues);
  };

  registerClickEvent = async (e, goalId) => {
    e.preventDefault();

    const [error, data] = await trackEvent(goalId, 'AFT');
  };

  handleBooktourSubmit = (e, openModal) => {
    e.preventDefault();

    openModal(modalIds.bookTour);
  };

  safeRender() {
    const fields = defaultsDeep(this.props.fields, defaultData);
    const { t, rendering } = this.props;
    const componentName = get(this.props, 'rendering.componentName', '');

    const goalId = get(this.props, 'fields.bookATourGoalId');

    const getGetInTouchButton = openModal => {
      const isGetInToucExternalLink = Boolean(
        get(fields, 'ExternalCTA.value.href'),
      );

      if (isGetInToucExternalLink) {
        const GetInTouchCTA = get(fields, 'ExternalCTA', {});
        return (
          <LinkWrapper
            field={GetInTouchCTA}
            componentName={componentName}
            isGTMTrackable
          />
        );
      }

      return (
        <button
          onClick={e => {
            processButtonData(componentName, t('GetInTouchCTA'));
            this.handleEnquirySubmit(e, openModal, fields);
          }}
          css={createButtonCss()}
        >
          {t('GetInTouchCTA')}
        </button>
      );
    };

    const isJssCtaPlaceholderAvailable =
      rendering && rendering.placeholders && rendering.placeholders['jss-cta'];

    return (
      <ModalsConsumer>
        {({ openModal }) => (
          <Container css={containerCtaCss}>
            <Row css={showElementCss(MediaQueries.mdAndUp, 'flex')}>
              <Column cols={{ md: 12, lg: 12 }}>
                {isJssCtaPlaceholderAvailable ? (
                  <Placeholder
                    name="jss-cta"
                    rendering={rendering}
                  />
                ) : (
                  getGetInTouchButton(openModal)
                )}
              </Column>

              <Column css={secondaryButtonCss} cols={{ md: 12, lg: 12 }}>
                <button
                  css={createButtonCss('secondary')}
                  onClick={e => {
                    this.registerClickEvent(e, { goalId });
                    processButtonData(componentName, t('BookAVisitCTA'));
                    this.handleBooktourSubmit(e, openModal);
                  }}
                  ref={this.secondaryButtonRef}
                >
                  {t('BookAVisitCTA')}
                </button>
                <span
                  css={[showElementCss(MediaQueries.lgAndUp), dividerCss]}
                />
              </Column>
            </Row>
          </Container>
        )}
      </ModalsConsumer>
    );
  }
}

Form.displayName = 'LocationHeader/Form';

Form.defaultProps = { fields: defaultData, t: key => key };

Form.propTypes = {
  fields: PropTypes.shape({
    ProtonName: PropTypes.shape({
      value: PropTypes.string,
    }),
    ExternalCTA: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string,
        target: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
  }),
};

export default withNamespaces('', {
  innerRef: ref => {
    if (ref.props.formRef) {
      ref.props.formRef.current = ref;
    }
  },
})(Form);
